import { LogbogAfsnit } from './LogbogAfsnit'; 
export class Logbog {
        public id: string;
        public titel: string;
        public beskrivelse: string;
        public aktiv: boolean;
        public createdDate: Date;
        public lastChangedDate: Date;
        public logbogAfsnit: LogbogAfsnit[];
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Logbog.ts